import React from 'react';
import { StyleSheet, Image, TouchableOpacity } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import generateID from 'shared/modules/common/utils/generate-id';
import BannerImgDesktop from 'web/assets/images/ekyc-banner-desktop.png';
import BannerImgMobile from 'web/assets/images/ekyc-banner-mobile.png';

const Banner = (props: { onPress: () => void }) => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });

  return (
    <TouchableOpacity
      style={[styles.touchableContainer, isBigScreen && styles.bigScreen]}
      onPress={props.onPress}
      {...generateID('start_kyc_banner')}
    >
      <Image
        source={{ uri: isBigScreen ? BannerImgDesktop : BannerImgMobile }}
        style={styles.banner}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  touchableContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    width: '100%',
    height: 352,
  },
  bigScreen: {
    width: 272,
    height: 324,
    alignSelf: 'flex-start',
  },
  banner: {
    flex: 1,
    width: '100%',
    height: '100%',
    resizeMode: 'contain',
  },
});

export default Banner;
